import React, { useState } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { VehicleModelGeneralInfo } from "./models";
import { VehicleModelGeneralInfoCreateForm } from "./ui-components";

import { ThemeProvider, createTheme } from "@aws-amplify/ui-react";
import { studioTheme } from "./ui-components";

const updatedTheme = createTheme(
  {
    // Extend the theme to update the button color
    name: "my-theme-updates",
    tokens: {
      components: {
        button: {
          primary: {
            backgroundColor: {
              value: "#b71c1c",
            },
          },
        },
      },
    },
  },
  studioTheme
);

const AddVehicle = () => {
  const handleSubmit = async (fields) => {
    try {
      // Create a new VehicleModelGeneralInfo instance
      const newVehicle = new VehicleModelGeneralInfo({
        Manufacturer: fields.Manufacturer,
        ModelName: fields.ModelName,
        ModelYear: parseInt(fields.ModelYear),
        VehicleType: fields.VehicleType,
        BodyStyle: fields.BodyStyle,
        EngineType: fields.EngineType,
        EnginePower: fields.EnginePower,
        FuelType: fields.FuelType,
        Transmission: fields.Transmission,
        Drivetrain: fields.Drivetrain,
        Acceleration: fields.Acceleration,
        TopSpeed: fields.TopSpeed,
        FuelEconomy: fields.FuelEconomy,
        InteriorFeatures: fields.InteriorFeatures,
        ExteriorFeatures: fields.ExteriorFeatures,
        SafetyFeatures: fields.SafetyFeatures,
        DriverAssistFeatures: fields.DriverAssistFeatures,
        CargoSpace: fields.CargoSpace,
        SeatingCapacity: parseInt(fields.SeatingCapacity),
        TireSize: fields.TireSize,
        Dimensions: fields.Dimensions,
        Wheelbase: fields.Wheelbase,
        Weight: fields.Weight,
        SuspensionType: fields.SuspensionType,
        BrakingSystem: fields.BrakingSystem,
        ColorOptions: fields.ColorOptions,
        Price: parseFloat(fields.Price),
        Warranty: fields.Warranty,
        EntertainmentSystem: fields.EntertainmentSystem,
        ConnectivityFeatures: fields.ConnectivityFeatures,
        Aerodynamics: fields.Aerodynamics,
        PerformancePackages: fields.PerformancePackages,
        Certifications: fields.Certifications,
        CountryOfOrigin: fields.CountryOfOrigin,
        CompetingModels: fields.CompetingModels,
        Information: fields.Information,
        Picture: fields.Picture
      });


      // Save the new vehicle to the DataStore
      await DataStore.save(newVehicle);

      console.log("Vehicle saved successfully:", newVehicle);
    } catch (error) {
      console.error("Error saving vehicle:", error);
    }
  };

  return (
    <>
      <VehicleModelGeneralInfoCreateForm onSubmit={handleSubmit} />
      <button type="submit" onClick={handleSubmit}>
        Submit
      </button>
      <div>
        {/* temp editing fix so submit button is visible */}
        <p>
          .

        </p>
      </div>
    </>

  );

};

export default AddVehicle;
